export default __webpack_public_path__ + "static/media/facebook_grey.143056d3.svg";